import { ArcadiaConfig, PlatformConfig } from '.';

interface ArcadiaConnectUrlParams {
  correlationId?: string;
  providerId?: string;
  originUrl?: string;
}

export function getArcadiaConnectUrl({ correlationId, providerId, originUrl }: ArcadiaConnectUrlParams): string {
  const orgId = ArcadiaConfig.orgId;
  const base = ArcadiaConfig.connectUrl;
  const path = `/${orgId}`;
  const params = new URLSearchParams({
    correlationId: correlationId ?? '',
    origin: originUrl ?? '',
  });
  if (PlatformConfig.isLive) {
    params.set('providerId', providerId ?? '');
  }
  if (!PlatformConfig.isLive) params.set('apiMode', 'sandbox');
  return `${base}${path}?${params.toString()}`;
}
